"use client";
import EventCard from "@/components/views/events/EventCard";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useVenueDetail } from "@/hooks/venueContext";

interface Props {
  events: Event.Detail[];
  venue?: Venue.Detail;
  className?: string;
  titleHeadingLevel: "h2" | "h3";
}

const EventDetailModal = dynamic(
  () => import("@/components/views/modals/event-and-campaign/EventDetailModal"),
);

export default function EventList(props: Props) {
  const [selectedEvent, setSelectedEvent] = useState<Event.Detail>(
    {} as Event.Detail,
  );
  const [modalOpen, setModalOpen] = useState(false);
  const { setVenue } = useVenueDetail();

  return (
    <>
      {props.events.map((event, index) => {
        return (
          <EventCard
            titleHeadingLevel={props.titleHeadingLevel}
            key={index}
            onClick={() => {
              setSelectedEvent({
                ...event,
                venue: (props.venue ?? event.venue) as Venue.List,
              });
              setModalOpen(true);
              setVenue((props.venue ?? event.venue) as Venue.List);
            }}
            {...event}
            venue={(props.venue ?? event.venue) as Venue.List}
          />
        );
      })}

      {modalOpen && (
        <EventDetailModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          event={selectedEvent}
        />
      )}
    </>
  );
}
